import instance from "@/services/api";

export const tierDailyAPI = {
  async getResidents() {
    return await instance()
      .get("/tier/resident/read/")
      .then((res) => res?.data);
  },
  async getBlocks(resident_id) {
    return await instance()
      .get("/tier/block/read/", { params: { resident_id } })
      .then((res) => res?.data);
  },
  async getWorkGroupDicts() {
    return await instance()
      .get("/common/blocks/work_group_dict/read/")
      .then((res) => res?.data);
  },
  async getWorkTaskFactDaily(date_, resident_id, block_id, work_group_dict_id) {
    const params = {
      date_,
    };
    if (resident_id) params.resident_id = resident_id;
    if (block_id) params.block_id = block_id;
    if (work_group_dict_id) params.work_group_dict_id = work_group_dict_id;
    
    return await instance()
      .get("/tier/work_task_fact/daily/", { params })
      .then((res) => res?.data);
  },
};

